import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";

interface JetIdResponse {
    jetId: string;
}

export default function usePaycometJetId(
    options?: CacheQueryOpts<JetIdResponse>
): CacheQueryOutput<JetIdResponse> {
    const client = useAPIClient();

    return useCacheQuery<JetIdResponse>(
        ["paycomet-jet-id"],
        () => client.get<JetIdResponse>("payment_cards/jet_id"),
        {
            execute: true,
            ...options,
        }
    );
}

